module.exports = __webpack_public_path__ + "img/page56.d5ef8d6c.gif";